<template>
    <div class="flex flex-row items-center h-full gap-x-3">
        <!-- <div class=" animate-pulse">
            <div :class="`w-${width} h-${width}`" class="bg-indigo-100 rounded-full animate-bounce" style="animation-delay: 0.150s;"></div>
        </div>
        <div class=" animate-pulse">
            <div :class="`w-${width} h-${width}`" class="bg-indigo-100 rounded-full animate-bounce"  style="animation-delay: 0.250s;"></div>
        </div>
        <div class=" animate-pulse">
            <div :class="`w-${width} h-${width}`" class="bg-indigo-100 rounded-full animate-bounce" style="animation-delay: 0.350s;"></div>
        </div> -->
      <svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve" class="animate-spin w-full h-full antialiased">
          <path style="fill: #ffffff" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50" shape-rendering="optimizeQuality"> </path>
      </svg>
    </div>
</template>

<script>
export default {
    name: 'ProgressSpinner',
    props: ['width'],
    data () {
        return {
        }
    }

}
</script>
<style scoped>
.loader div {
  animation-duration: 1s;
}

.loader div:first-child {
  animation-delay: 0.150s;
}

.loader div:nth-child(2) {
  animation-delay: 0.250s;
}

.loader div:nth-child(3) {
  animation-delay: 0.350s;
}
</style>
